import { Selecting, useToastProvider } from '@qualio/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '../../../../../../../../api/model/document';
import { CredentialConfirmationModal } from '../../../../../../CredentialConfirmationModal/index';
import { WorkspaceTabs } from '../../../../WorkspaceV2';
import { handleStatusChange } from '../ChangeStatusService';
import {
  ChangeStatusButtonProps,
  IsChangeStatusActionAllowedCallback,
} from '../types';

import { useTableDataInvalidation } from '../../../../hooks/useTableDataInvalidation';
import {
  hasAllowedStatusesForAction,
  hasRequiredPermissionsForAction,
  isValidTabForAction,
} from '../../../BulkActions';
import { BulkActionButton } from '../../BulkActionButton/index';

export const RetireButton = (props: ChangeStatusButtonProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onClose = () => setIsModalOpen(false);
  const { selectedDocuments } = props;
  const selection = Selecting.useSelectionMaybe();
  const { invalidate } = useTableDataInvalidation();

  const buttonActionLabel = t('buttons.retire');
  const modalHeading = t('modals.retireDocument');

  const toastActionStringActive = t('buttons.retire').toLowerCase();
  const toastActionStringPassive = t('statuses.retired').toLowerCase();

  const handleRetire = async (
    email: string,
    password: string,
    comment?: string,
  ) => {
    await handleStatusChange(
      selectedDocuments,
      { status: DocumentStatus.Retired, email, password, comment },
      selection?.setSelection as any,
      showToast,
      toastActionStringActive,
      toastActionStringPassive,
    );
    setIsModalOpen(false);
    void invalidate(props.currentTab);
  };

  const canRetire: IsChangeStatusActionAllowedCallback = (
    user,
    statuses,
    activeTab,
    requiredPermissions,
    selectedDocuments,
  ) => {
    if (selectedDocuments.length > 1) {
      return false;
    }
    if (
      !hasRequiredPermissionsForAction(requiredPermissions, user.permissions) ||
      !isValidTabForAction([WorkspaceTabs.ALL_DOCUMENTS], activeTab)
    ) {
      return false;
    }
    return hasAllowedStatusesForAction([DocumentStatus.Effective], statuses);
  };

  return (
    <>
      <BulkActionButton
        {...props}
        isActionAllowed={canRetire}
        onClick={() => setIsModalOpen(true)}
      />
      <CredentialConfirmationModal
        isOpen={isModalOpen}
        onCloseModal={onClose}
        handleStatusChange={handleRetire}
        modalText={
          <>
            {t('modals.retiringDocumentTrainingImpact')}
            <br />
            <br />
            {t('modals.enterDigitalSignatureRetire')}
          </>
        }
        modalHeading={modalHeading}
        buttonActionLabel={buttonActionLabel}
        buttonProps={{ isDestructive: true }}
      />
    </>
  );
};
